import React from 'react'

type Props = {
  isOpen: boolean
  open: () => void
  close: () => void
}

const NewBurger = ({ isOpen, open, close }: Props) => {
  return (
    <button onClick={() => (isOpen ? close() : open())} className='burger' aria-label='burger'>
      <svg viewBox='0 0 20 20' fill='none'>
        {/* ex */}
        {isOpen && (
          <g className='burger__ex'>
            <path d='M4,4 L16,16' />
            <path d='M16,4 L4,16' />
          </g>
        )}
        {/* burger */}
        {!isOpen && (
          <g className='burger__burger'>
            <path d='M0,3 20,3' />
            <path d='M0,10 20,10' />
            <path d='M0,17 20,17' />
          </g>
        )}
      </svg>
    </button>
  )
}

export default NewBurger
